import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { map, times } from 'lodash/fp';

import EmptySlots from './EmptySlots/index';
import { slotPropType } from '../../../../../propTypes/index';
import styles from './slots.module.css';

const createSlot = (time, doctorId, appointmentId, sessionId, setTime) => (
  <div
    className={styles.slot}
    key={appointmentId}
    id="nw_slot"
    onClick={() => setTime(doctorId, appointmentId, time, sessionId)}
  >
    {moment(time).format('h:mm a')}
  </div>
);

const createDash = () => (
  <div className={styles.dash} key={Math.random()}>
    <hr />
  </div>
);

const getShortcutButton = (
  hasMorningSlots,
  filterMorning,
  hasAfternoonSlots,
  filterAfternoon,
  hasEveningSlots,
  filterEvening,
  currentFilter,
) => {
  if (hasMorningSlots && currentFilter !== 'morning') {
    return (
      <div className={styles.otherSlots} onClick={filterMorning}>
        Morning Slots
      </div>
    );
  } else if (hasAfternoonSlots && currentFilter !== 'afternoon') {
    return (
      <div className={styles.otherSlots} onClick={filterAfternoon}>
        Afternoon Slots
      </div>
    );
  } else if (hasEveningSlots && currentFilter !== 'evening') {
    return (
      <div className={styles.otherSlots} onClick={filterEvening}>
        Evening Slots
      </div>
    );
  }
};

const Slots = ({
  toggleShowAll,
  showAll,
  setTime,
  doctorId,
  appointments,
  currentFilter,
  hasAvailableSlots,
  maxLength,
  hasMorningSlots,
  hasAfternoonSlots,
  hasEveningSlots,
  filterMorning,
  filterAfternoon,
  filterEvening,
  sessionId,
}) => {
  if (!appointments.length) {
    return (
      <div className={styles.slotsContainer}>
        <EmptySlots
          hasAvailableSlots={hasAvailableSlots}
          currentFilter={currentFilter}
          maxLength={maxLength}
          showAll={showAll}
        />
        {getShortcutButton(
          hasMorningSlots,
          filterMorning,
          hasAfternoonSlots,
          filterAfternoon,
          hasEveningSlots,
          filterEvening,
          currentFilter,
        )}
      </div>
    );
  }
  return (
    <div className={styles.slotsContainer}>
      {map(s => createSlot(s.Time, doctorId, s.Guid, sessionId, setTime))(
        showAll ? appointments : appointments.slice(0, 3),
      )}
      {appointments.length < 3 &&
        times(() => createDash())(3 - appointments.length)}
      {showAll &&
        appointments.length < maxLength &&
        times(() => createDash())(maxLength - appointments.length)}

      {hasAvailableSlots && appointments.length > 3 && (
        <div className={styles.seeMore} onClick={toggleShowAll}>
          {showAll ? 'See less' : 'See more'}
        </div>
      )}

      {getShortcutButton(
        hasMorningSlots,
        filterMorning,
        hasAfternoonSlots,
        filterAfternoon,
        hasEveningSlots,
        filterEvening,
        currentFilter,
      )}
    </div>
  );
};

Slots.propTypes = {
  toggleShowAll: PropTypes.func.isRequired,
  setTime: PropTypes.func.isRequired,
  doctorId: PropTypes.string.isRequired,
  appointments: PropTypes.arrayOf(slotPropType).isRequired,
  currentFilter: PropTypes.string.isRequired,
  hasAvailableSlots: PropTypes.bool.isRequired,
  showAll: PropTypes.bool.isRequired,
  maxLength: PropTypes.number,
};

export default Slots;
